import { Comunidad, ComunidadTiposGastos } from "./comunidad";
import { DialogCargaMovimientoItem } from "./movimiento";

export class Gasto {
    constructor(
        public readonly Id: number,
        public readonly TipoGastoId: number | null,
        public readonly TipoGasto: string | null,
        public readonly TipoGastoComunidad: ComunidadTiposGastos | null,
        public readonly ServicioGastoId: number | null,
        public readonly ServicioGastoNombre: string | null,
        public readonly FechaGasto: Date,

        public readonly FechaVencimiento: Date,
        public readonly FechaVencimiento2: Date,

        public readonly Detalle: string | null,
        public readonly Observaciones: string | null,
        public readonly MonedaId: number | null,
        public readonly MonedaNombre: string | null,

        public readonly Importe: number | null,
        public readonly Importe2: number | null,
        public readonly ImporteBase: number | null,
        public readonly ImporteBase2: number | null,

        public readonly AlicuotaIvaId: number | null,
        public readonly AlicuotaIvaNombre: number | null,
        public readonly ImporteAlicuotaIva: number | null,
        public readonly ImporteAlicuotaIva2: number | null,

        public PermitirGenerarInteres: boolean | null,
        public Activo: boolean,

        public readonly ConsorcioId: number,
        public readonly ComunidadId: number | null,
        public readonly Comunidad: Comunidad | null,
        public readonly UnidadFuncionalId: number | null,
        public readonly ExpensaCabeceraId: number | null,
        public readonly ProveedorId: number | null,
        public readonly ProveedorNombre: string | null,

        public readonly EsRecurrente: boolean,
        public readonly PeriodicidadRecurrencia: number | null,

        public readonly Editable: boolean,

        public Adjuntos: GastoAdjunto[]
    ) {}
}

export class SaveGastoRequestDto {
    constructor(
        public readonly Id: number,

        public readonly TipoGastoId: number | null,
        public readonly ServicioGastoId: number | null,
        public readonly FechaGasto: Date | null,

        public readonly FechaVencimiento: Date | null,
        public readonly FechaVencimiento2: Date | null,

        public readonly Detalle: string | null,
        public readonly Observaciones: number | null,
        public readonly MonedaId: number | null,
        public readonly AlicuotaIvaId: number | null,

        public readonly ImporteBase: number | null,
        public readonly ImporteBase2: number | null,

        public readonly Activo: boolean,

        public readonly ConsorcioId: number | null,
        public readonly ComunidadId: number | null,
        public readonly UnidadFuncionalId: number | null,

        public readonly EsRecurrente: boolean | null,
        public readonly PeriodicidadRecurrencia: number | null,

        public Adjuntos: GastoAdjunto[],
        public readonly Deudas: DialogCargaMovimientoItem[],
    ) {}
}

export class GastoAdjunto {
    constructor (
        public readonly Id: number,
        public readonly NombreDocumento: string | null,
        public readonly UrlDocumento: string | null,
        public readonly PermitirAccederPublicamente: boolean
    ) {}
}

export class UploadGastoAttachResponseDto {
    constructor (
        public readonly Archivos: GastoAdjunto[]
    ) {}
}

export class SearchGastoRequest {
    constructor (
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Detalle: string | null,
        public readonly FechaGastoDesde: Date | null,
        public readonly FechaGastoHasta: Date | null,
        public readonly ProveedorId: number | null,
        public readonly ConsorcioId: number | null,
        public readonly ComunidadId: number | null,
        public readonly UnidadFuncionalId: number | null,
        public readonly UnidadFuncionalCodigo: string | null,
        public readonly TipoGastoId: number | null,
        public readonly ServicioGastoId: number | null,
        public readonly ClaseGasto: number | null,
        public readonly MonedaId: number | null,
        public readonly VerSoloPendientesLiquidacion: boolean | null,
        public readonly VerSoloRecurrentes: boolean | null,
        public readonly VerSoloActivos: boolean | null
    ) {}
}

export class SearchGastoResponse {
    constructor(
      public readonly count: number,
      public readonly result: SearchGastoItem[]
    ) {}
}

export class SearchGastoItem {
    constructor(
        public readonly Id: number,
        public readonly FechaGasto: Date,
        public readonly TipoGasto: string | null,
        public readonly ServicioGasto: string | null,
        public readonly ReferenciaId: number,
        public readonly Comunidad: string | null,
        public readonly UfCodigo: string | null,
        public readonly TipoReferencia: string | null,
        public readonly Detalle: string | null,
        public readonly MonedaId: number,
        public readonly Moneda: string | null,
        public readonly Importe: number,
        public MontoPago: number,
        public readonly AlicuotaIvaId: number,
        public readonly AlicuotaIvaValor: number
    ) {}
}

export class SearchPendientesLiquidacionRequest {
    constructor (
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly PeriodoLiquidacion: Date | null,
        public readonly ConsorcioId: number | null,
        public readonly ComunidadId: number | null,
        public readonly TipoGastoId: number | null,
        public readonly MonedaId: number | null,
        public readonly ServicioGastoListString: string | null,
        public readonly ServicioGastoList: number[],
        public readonly VerOtrosGastosPendientes: boolean | null,
        public readonly FechaGastoDesde: Date | null,
        public readonly FechaGastoHasta: Date | null
    ) {}
}

export class SearchPendientesLiquidacionItem {
    constructor(
        public readonly Id: number,
        public readonly FechaGasto: Date,
        public readonly TipoGastoId: number,
        public readonly TipoGasto: string | null,
        public readonly ServicioGastoId: number,
        public readonly ServicioGasto: string | null,
        public readonly Detalle: string | null,
        public readonly MonedaId: number,
        public readonly Moneda: string | null,
        public readonly Importe: number,
        public readonly ComunidadId: number,
        public readonly Comunidad: string | null,
        public readonly UnidadFuncionalId: number,
        public readonly UnidadFuncionalCodigo: string | null,
        public readonly UnidadFuncionalNumero: number
    ) {}
}

export class ExpensaResumenLiquidacionGastosDto {
    constructor(
        public readonly Id: number,
        public readonly TipoGastoId: number,
        public readonly TipoGasto: string | null,
        public readonly ServicioGastoId: number,
        public readonly ServicioGastoNombre: string | null,
        public readonly ServicioGastoCategoriaId: number,
        public readonly ServicioGastoCategoriaNombre: string | null,
        public readonly FechaGasto: Date,
        public readonly FechaVencimiento: Date,
        public readonly FechaVencimiento2: Date,
        public readonly Detalle: string | null,
        public readonly Observaciones: string | null,
        public readonly MonedaId: number,
        public readonly MonedaNombre: string | null,
        public readonly Importe: number,
        public readonly Importe2: number,
        public readonly Activo: boolean,
        public readonly ConsorcioId: number,
        public readonly ComunidadId: number
    ) {}
}

export class DashboardGastosPorServicioRequest {
    constructor(
        public readonly ConsorcioId: number
    ) {}
}

export class DashboardGastosPorTipoGastoRequest {
    constructor(
        public readonly ConsorcioId: number
    ) {}
}

export class SaveGastoMovimientoDto {
    constructor(
        public readonly GastoId: number,
        public readonly Deudas: DialogCargaMovimientoItem[]
    ) {}
}

export class SearchGastoRecurrenteRequest {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,

        public readonly Detalle: string | null,
        public readonly FechaGastoDesde: Date | null,
        public readonly FechaGastoHasta: Date | null,
        public readonly ProveedorId: number | null,
        public readonly ConsorcioId: number | null,
        public readonly ComunidadId: number | null,
        public readonly UnidadFuncionalId: number | null,
        public readonly UnidadFuncionalCodigo: string | null,
        public readonly TipoGastoId: number | null,
        public readonly ServicioGastoId: number | null,
        public readonly ClaseGasto: number | null,
        public readonly MonedaId: number | null,

        public readonly VerSoloPendientesLiquidacion: boolean | null,
        public readonly VerSoloRecurrentes: boolean | null,
        public readonly VerSoloActivos: boolean | null
    ) {}
}

export class SaveGastoFromDocumentRequestDto {
    constructor(
      public readonly Urls: string[]
    ) {}
}

export class SaveGastoFromDocumentResponseDto {
    constructor(
        public readonly Gastos: Gasto[]
    ) {}
}

export class GastoAdjuntoPublicoQrResponseDto {
    constructor(
        public readonly ExpensaPeriodo: string | null,
        public readonly ComunidadNombre: string | null,
        public readonly TenantNombre: string | null,
        public readonly Items: GastoAdjuntoPublicoQrItemDto[],
    ) {}
}

export class GastoAdjuntoPublicoQrItemDto {
    constructor(
        public readonly AdjuntoId: number,
        public readonly GastoId: number,
        public readonly AdjuntoUrl: string | null,
        public readonly AdjuntoNombre: string | null,
        public readonly ExpensaPeriodo: string | null,
        public readonly ComunidadNombre: string | null,
        public readonly TenantNombre: string | null,
    ) {}
}
